export default "__VITE_ASSET__202e4fbe__"